import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_SUBSCRIPTION_INVITATION_CHECKOUT_BEGIN,
  USER_SUBSCRIPTION_INVITATION_CHECKOUT_SUCCESS,
  USER_SUBSCRIPTION_INVITATION_CHECKOUT_FAILURE,
  USER_SUBSCRIPTION_INVITATION_CHECKOUT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function subscriptionInvitationCheckout(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_SUBSCRIPTION_INVITATION_CHECKOUT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/users/subscription-invitation-checkout/`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_SUBSCRIPTION_INVITATION_CHECKOUT_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_SUBSCRIPTION_INVITATION_CHECKOUT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSubscriptionInvitationCheckoutError() {
  return {
    type: USER_SUBSCRIPTION_INVITATION_CHECKOUT_DISMISS_ERROR,
  };
}

export function useSubscriptionInvitationCheckout() {
  const dispatch = useDispatch();

  const {
    subscriptionInvitationCheckoutPending,
    subscriptionInvitationCheckoutError,
  } = useSelector(
    (state) => ({
      subscriptionInvitationCheckoutPending:
        state.user.subscriptionInvitationCheckoutPending,
      subscriptionInvitationCheckoutError:
        state.user.subscriptionInvitationCheckoutError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(subscriptionInvitationCheckout(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissSubscriptionInvitationCheckoutError());
  }, [dispatch]);

  return {
    subscriptionInvitationCheckout: boundAction,
    subscriptionInvitationCheckoutPending,
    subscriptionInvitationCheckoutError,
    dismissSubscriptionInvitationCheckoutError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_SUBSCRIPTION_INVITATION_CHECKOUT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        subscriptionInvitationCheckoutPending: true,
        subscriptionInvitationCheckoutError: null,
      };

    case USER_SUBSCRIPTION_INVITATION_CHECKOUT_SUCCESS:
      // The request is success
      return {
        ...state,
        subscriptionInvitationCheckoutPending: false,
        subscriptionInvitationCheckoutError: null,
      };

    case USER_SUBSCRIPTION_INVITATION_CHECKOUT_FAILURE:
      // The request is failed
      return {
        ...state,
        subscriptionInvitationCheckoutPending: false,
        subscriptionInvitationCheckoutError: action.data.error,
      };

    case USER_SUBSCRIPTION_INVITATION_CHECKOUT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        subscriptionInvitationCheckoutError: null,
      };

    default:
      return state;
  }
}
